<div [ngClass]="[addMargin ? 'ml-15' : '', 'px-2 pb-2']">
  <div [innerHTML]="expanded ? allHighlights : filteredHighlights"></div>

  <div class="flex justify-center">
    @if (allHighlights.length !== filteredHighlights.length) {
      <button mat-icon-button (click)="expanded = !expanded">
        <mat-icon>{{ expanded ? 'remove' : 'add' }}</mat-icon>
      </button>
    }
  </div>
</div>
